import React, { useCallback } from 'react';
import { FormControl, Grid } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MainSelect from '../../../MUI/MainSelect';
import Validation from '../../../Validation/Validation';
import { getMenuLabelWithTranslation } from '../../../../helpers/selectHelpers';

const ArmenianRegionSelectOptions = ({
  errors,
  clearError,
  states,
  onStateChange,
  disabledInputs,
  form,
  cityVillages,
  onCityVillageChange,
  isYerevan,
}) => {
  const { i18n } = useTranslation();

  const getLabelWithTranslation = useCallback(
    (option) => getMenuLabelWithTranslation(option, i18n),
    [i18n],
  );

  return (
    <>
      <Grid item xs={12} md={isEmpty(form.state.value) || isYerevan ? 6 : 4}>
        <Validation name={form.state.name} errors={errors} clearError={clearError}>
          <FormControl fullWidth>
            <MainSelect
              name={form.state.name}
              label={form.state.label}
              value={form.state.value}
              disabled={disabledInputs.includes('state')}
              options={states}
              getMenuLabel={getLabelWithTranslation}
              onChange={onStateChange}
              required
            />
          </FormControl>
        </Validation>
      </Grid>
      {!isYerevan && !isEmpty(form.state.value) && (
        <Grid item xs={12} md={4}>
          <Validation name={form.cityVillage.name} errors={errors} clearError={clearError}>
            <FormControl fullWidth>
              <MainSelect
                name={form.cityVillage.name}
                label={form.cityVillage.label}
                value={form.cityVillage.value}
                disabled={disabledInputs.includes('cityVillage')}
                options={cityVillages}
                getMenuLabel={getLabelWithTranslation}
                onChange={onCityVillageChange}
                required
              />
            </FormControl>
          </Validation>
        </Grid>
      )}
    </>
  );
};

ArmenianRegionSelectOptions.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  clearError: PropTypes.func.isRequired,
  states: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  form: PropTypes.shape({
    cityVillage: PropTypes.shape({
      value: PropTypes.shape({}),
      label: PropTypes.string,
      name: PropTypes.string,
    }),
    state: PropTypes.shape({
      value: PropTypes.shape({
        id: PropTypes.number,
      }),
      label: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  disabledInputs: PropTypes.arrayOf(PropTypes.string),
  cityVillages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onCityVillageChange: PropTypes.func.isRequired,
  isYerevan: PropTypes.bool.isRequired,
  onStateChange: PropTypes.func.isRequired,
};

ArmenianRegionSelectOptions.defaultProps = {
  disabledInputs: [],
};

export default ArmenianRegionSelectOptions;
